import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { CandidateType, SortOrderEnum, handleRequestError, handleServerCoverageListData } from '@jove-frontend/uikit';
import { api } from '.';
export var apiGetAllOrganizations = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$limit, limit, _ref$offset, offset, _ref$sortOrder, sortOrder, _ref$sortColumn, sortColumn, name, slug, organizationId, q, parent_organization_id, params, res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 1000 : _ref$limit, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0 : _ref$offset, _ref$sortOrder = _ref.sortOrder, sortOrder = _ref$sortOrder === void 0 ? SortOrderEnum.ASC : _ref$sortOrder, _ref$sortColumn = _ref.sortColumn, sortColumn = _ref$sortColumn === void 0 ? 'name' : _ref$sortColumn, name = _ref.name, slug = _ref.slug, organizationId = _ref.organizationId, q = _ref.q, parent_organization_id = _ref.parent_organization_id;
            _context.prev = 1;
            params = new URLSearchParams();
            params.append('limit', limit.toString());
            params.append('offset', offset.toString());
            params.append('sort_column', sortColumn);
            params.append('sort_order', sortOrder);
            if (name) params.append('name', name);
            if (slug) params.append('slug', slug);
            if (q) params.append('q', q);
            if (parent_organization_id) params.append('parent_organization_id', parent_organization_id);
            organizationId === null || organizationId === void 0 ? void 0 : organizationId.forEach(function (id) {
              return params.append('organization_id', id);
            });
            _context.next = 14;
            return api.get('/organizations', {
              params: params
            });

          case 14:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to fetch organizations because: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));

  return function apiGetAllOrganizations(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiGetAllParentOrganizations = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var _ref3$limit, limit, _ref3$offset, offset, _ref3$sortOrder, sortOrder, _ref3$sortColumn, sortColumn, params, res, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref3$limit = _ref3.limit, limit = _ref3$limit === void 0 ? 1000 : _ref3$limit, _ref3$offset = _ref3.offset, offset = _ref3$offset === void 0 ? 0 : _ref3$offset, _ref3$sortOrder = _ref3.sortOrder, sortOrder = _ref3$sortOrder === void 0 ? SortOrderEnum.ASC : _ref3$sortOrder, _ref3$sortColumn = _ref3.sortColumn, sortColumn = _ref3$sortColumn === void 0 ? 'name' : _ref3$sortColumn;
            _context2.prev = 1;
            params = new URLSearchParams();
            params.append('limit', limit.toString());
            params.append('offset', offset.toString());
            params.append('sort_column', sortColumn);
            params.append('sort_order', sortOrder);
            _context2.next = 9;
            return api.get('/organizations/parents', {
              params: params
            });

          case 9:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](1);
            message = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg;
            console.error("Failed to fetch organizations because: ".concat(message));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 13]]);
  }));

  return function apiGetAllParentOrganizations(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiGetOrganization = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(organizationIdOrSlug) {
    var res, _err$response3, _err$response3$data, _err$response3$data$d, _err$response3$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (organizationIdOrSlug) {
              _context3.next = 3;
              break;
            }

            throw new Error("Invalid organization id or slug: ".concat(organizationIdOrSlug));

          case 3:
            _context3.next = 5;
            return api.get("/organizations/".concat(organizationIdOrSlug));

          case 5:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data.data.organization]);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            message = (_err$response3 = _context3.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$d = _err$response3$data.detail) === null || _err$response3$data$d === void 0 ? void 0 : (_err$response3$data$d2 = _err$response3$data$d[0]) === null || _err$response3$data$d2 === void 0 ? void 0 : _err$response3$data$d2.msg;
            console.error("Failed to fetch organization because: ".concat(message));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 9]]);
  }));

  return function apiGetOrganization(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiCreateOrganization = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res, _err$response4, _err$response4$data, _err$response4$data$d, _err$response4$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.post('/organizations', payload);

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data.data.organization]);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            message = (_err$response4 = _context4.t0.response) === null || _err$response4 === void 0 ? void 0 : (_err$response4$data = _err$response4.data) === null || _err$response4$data === void 0 ? void 0 : (_err$response4$data$d = _err$response4$data.detail) === null || _err$response4$data$d === void 0 ? void 0 : (_err$response4$data$d2 = _err$response4$data$d[0]) === null || _err$response4$data$d2 === void 0 ? void 0 : _err$response4$data$d2.msg;
            console.error("Failed to update organization because: ".concat(message));
            return _context4.abrupt("return", [null, _context4.t0]);

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function apiCreateOrganization(_x4) {
    return _ref6.apply(this, arguments);
  };
}();
export var apiUpdateOrganization = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(organizationId, payload) {
    var res, _err$response5, _err$response5$data, _err$response5$data$d, _err$response5$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.patch("/organizations/".concat(organizationId), payload);

          case 3:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data.data.organization]);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            message = (_err$response5 = _context5.t0.response) === null || _err$response5 === void 0 ? void 0 : (_err$response5$data = _err$response5.data) === null || _err$response5$data === void 0 ? void 0 : (_err$response5$data$d = _err$response5$data.detail) === null || _err$response5$data$d === void 0 ? void 0 : (_err$response5$data$d2 = _err$response5$data$d[0]) === null || _err$response5$data$d2 === void 0 ? void 0 : _err$response5$data$d2.msg;
            console.error("Failed to update organization because: ".concat(message));
            return _context5.abrupt("return", [null, _context5.t0]);

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));

  return function apiUpdateOrganization(_x5, _x6) {
    return _ref7.apply(this, arguments);
  };
}();
export var apiUloadOrganizationLogo = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(organizationId, file) {
    var formData, res, _err$response$data$de3, _err$response6, _err$response6$data, _err$response6$data$d, _err$response6$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;

            if (organizationId) {
              _context6.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            formData = new FormData();
            formData.append('file', file);
            _context6.next = 7;
            return api.post("/organizations/".concat(organizationId, "/logo"), formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 7:
            res = _context6.sent;
            return _context6.abrupt("return", [res.data]);

          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](0);
            message = (_err$response$data$de3 = (_err$response6 = _context6.t0.response) === null || _err$response6 === void 0 ? void 0 : (_err$response6$data = _err$response6.data) === null || _err$response6$data === void 0 ? void 0 : (_err$response6$data$d = _err$response6$data.detail) === null || _err$response6$data$d === void 0 ? void 0 : (_err$response6$data$d2 = _err$response6$data$d[0]) === null || _err$response6$data$d2 === void 0 ? void 0 : _err$response6$data$d2.msg) !== null && _err$response$data$de3 !== void 0 ? _err$response$data$de3 : _context6.t0;
            console.error("Failed to upload organization logo: ".concat(message));
            return _context6.abrupt("return", [null, _context6.t0]);

          case 16:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 11]]);
  }));

  return function apiUloadOrganizationLogo(_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}();
export var apiGetOrganizationRegions = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(organizationId, extraData) {
    var res, _err$response$data$de4, _err$response7, _err$response7$data, _err$response7$data$d, _err$response7$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;

            if (organizationId) {
              _context7.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            _context7.next = 5;
            return api.get('/organization_region', {
              params: _objectSpread(_objectSpread({
                organization_id: organizationId
              }, extraData), {}, {
                candidate_type: (extraData === null || extraData === void 0 ? void 0 : extraData.candidate_type) || CandidateType.CANDIDATE
              })
            });

          case 5:
            res = _context7.sent;
            return _context7.abrupt("return", [res.data]);

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](0);
            message = (_err$response$data$de4 = (_err$response7 = _context7.t0.response) === null || _err$response7 === void 0 ? void 0 : (_err$response7$data = _err$response7.data) === null || _err$response7$data === void 0 ? void 0 : (_err$response7$data$d = _err$response7$data.detail) === null || _err$response7$data$d === void 0 ? void 0 : (_err$response7$data$d2 = _err$response7$data$d[0]) === null || _err$response7$data$d2 === void 0 ? void 0 : _err$response7$data$d2.msg) !== null && _err$response$data$de4 !== void 0 ? _err$response$data$de4 : _context7.t0;
            console.error("Failed to retrieve organization regions: ".concat(message));
            return _context7.abrupt("return", [null, _context7.t0]);

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 9]]);
  }));

  return function apiGetOrganizationRegions(_x9, _x10) {
    return _ref9.apply(this, arguments);
  };
}();
export var apiGetOrganizationRegion = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(regionId) {
    var res, _err$response$data$de5, _err$response8, _err$response8$data, _err$response8$data$d, _err$response8$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;

            if (regionId) {
              _context8.next = 3;
              break;
            }

            throw new Error("Invalid region id: ".concat(regionId));

          case 3:
            _context8.next = 5;
            return api.get("/organization_region/".concat(regionId));

          case 5:
            res = _context8.sent;
            return _context8.abrupt("return", [res.data]);

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](0);
            message = (_err$response$data$de5 = (_err$response8 = _context8.t0.response) === null || _err$response8 === void 0 ? void 0 : (_err$response8$data = _err$response8.data) === null || _err$response8$data === void 0 ? void 0 : (_err$response8$data$d = _err$response8$data.detail) === null || _err$response8$data$d === void 0 ? void 0 : (_err$response8$data$d2 = _err$response8$data$d[0]) === null || _err$response8$data$d2 === void 0 ? void 0 : _err$response8$data$d2.msg) !== null && _err$response$data$de5 !== void 0 ? _err$response$data$de5 : _context8.t0;
            console.error("Failed to retrieve organization region: ".concat(message));
            return _context8.abrupt("return", [null, _context8.t0]);

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 9]]);
  }));

  return function apiGetOrganizationRegion(_x11) {
    return _ref10.apply(this, arguments);
  };
}();
export var apiGetOrganizationRegionByCountryCode = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(organizationId, countryCode, config) {
    var _res$data, _res$data$data, _res$data3, _res$data3$data, res, _res$data2, _res$data2$data, _err$response$data$de6, _err$response9, _err$response9$data, _err$response9$data$d, _err$response9$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;

            if (organizationId) {
              _context9.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            _context9.next = 5;
            return api.get('/organization_region', {
              params: {
                organization_id: organizationId,
                country_code: countryCode,
                candidate_type: (config === null || config === void 0 ? void 0 : config.candidateType) || CandidateType.CANDIDATE
              }
            });

          case 5:
            res = _context9.sent;

            if ((_res$data = res.data) !== null && _res$data !== void 0 && (_res$data$data = _res$data.data) !== null && _res$data$data !== void 0 && _res$data$data[0]) {
              res.data.data[0].coverages = handleServerCoverageListData((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : _res$data2$data[0].coverages);
            }

            return _context9.abrupt("return", [(_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$data = _res$data3.data) === null || _res$data3$data === void 0 ? void 0 : _res$data3$data[0]]);

          case 10:
            _context9.prev = 10;
            _context9.t0 = _context9["catch"](0);
            message = (_err$response$data$de6 = (_err$response9 = _context9.t0.response) === null || _err$response9 === void 0 ? void 0 : (_err$response9$data = _err$response9.data) === null || _err$response9$data === void 0 ? void 0 : (_err$response9$data$d = _err$response9$data.detail) === null || _err$response9$data$d === void 0 ? void 0 : (_err$response9$data$d2 = _err$response9$data$d[0]) === null || _err$response9$data$d2 === void 0 ? void 0 : _err$response9$data$d2.msg) !== null && _err$response$data$de6 !== void 0 ? _err$response$data$de6 : _context9.t0;
            console.error("Failed to retrieve organization regions: ".concat(message));
            return _context9.abrupt("return", [null, _context9.t0]);

          case 15:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 10]]);
  }));

  return function apiGetOrganizationRegionByCountryCode(_x12, _x13, _x14) {
    return _ref11.apply(this, arguments);
  };
}();
export var apiCreateOrganizationRegion = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(payload) {
    var res, _err$response$data$de7, _err$response10, _err$response10$data, _err$response10$data$, _err$response10$data$2, message;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return api.post('/organization_region', payload);

          case 3:
            res = _context10.sent;
            return _context10.abrupt("return", [res.data]);

          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10["catch"](0);
            message = (_err$response$data$de7 = (_err$response10 = _context10.t0.response) === null || _err$response10 === void 0 ? void 0 : (_err$response10$data = _err$response10.data) === null || _err$response10$data === void 0 ? void 0 : (_err$response10$data$ = _err$response10$data.detail) === null || _err$response10$data$ === void 0 ? void 0 : (_err$response10$data$2 = _err$response10$data$[0]) === null || _err$response10$data$2 === void 0 ? void 0 : _err$response10$data$2.msg) !== null && _err$response$data$de7 !== void 0 ? _err$response$data$de7 : _context10.t0;
            console.error("Failed to create organization region: ".concat(message));
            return _context10.abrupt("return", [null, _context10.t0]);

          case 12:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 7]]);
  }));

  return function apiCreateOrganizationRegion(_x15) {
    return _ref12.apply(this, arguments);
  };
}();
export var apiUpdateOrganizationRegion = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(regionId, payload) {
    var res, _err$response$data$de8, _err$response11, _err$response11$data, _err$response11$data$, _err$response11$data$2, message;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;

            if (regionId) {
              _context11.next = 3;
              break;
            }

            throw new Error("Invalid organization region id: ".concat(regionId));

          case 3:
            _context11.next = 5;
            return api.put("/organization_region/".concat(regionId), payload);

          case 5:
            res = _context11.sent;
            return _context11.abrupt("return", [res.data]);

          case 9:
            _context11.prev = 9;
            _context11.t0 = _context11["catch"](0);
            message = (_err$response$data$de8 = (_err$response11 = _context11.t0.response) === null || _err$response11 === void 0 ? void 0 : (_err$response11$data = _err$response11.data) === null || _err$response11$data === void 0 ? void 0 : (_err$response11$data$ = _err$response11$data.detail) === null || _err$response11$data$ === void 0 ? void 0 : (_err$response11$data$2 = _err$response11$data$[0]) === null || _err$response11$data$2 === void 0 ? void 0 : _err$response11$data$2.msg) !== null && _err$response$data$de8 !== void 0 ? _err$response$data$de8 : _context11.t0;
            console.error("Failed to update organization region ".concat(regionId, ": ").concat(message));
            return _context11.abrupt("return", [null, _context11.t0]);

          case 14:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 9]]);
  }));

  return function apiUpdateOrganizationRegion(_x16, _x17) {
    return _ref13.apply(this, arguments);
  };
}();
export var apiDeleteOrganizationRegion = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(regionId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;

            if (regionId) {
              _context12.next = 3;
              break;
            }

            throw new Error("Invalid organization region id: ".concat(regionId));

          case 3:
            _context12.next = 5;
            return api["delete"]("/organization_region/".concat(regionId));

          case 5:
            res = _context12.sent;
            return _context12.abrupt("return", [res.data]);

          case 9:
            _context12.prev = 9;
            _context12.t0 = _context12["catch"](0);
            return _context12.abrupt("return", handleRequestError(_context12.t0));

          case 12:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 9]]);
  }));

  return function apiDeleteOrganizationRegion(_x18) {
    return _ref14.apply(this, arguments);
  };
}();
export var apiGetApiKeys = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(organizationId) {
    var res, _err$response$data$de9, _err$response12, _err$response12$data, _err$response12$data$, _err$response12$data$2, message;

    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;

            if (organizationId) {
              _context13.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            _context13.next = 5;
            return api.get("/organizations/".concat(organizationId, "/api_keys"));

          case 5:
            res = _context13.sent;
            return _context13.abrupt("return", [res.data]);

          case 9:
            _context13.prev = 9;
            _context13.t0 = _context13["catch"](0);
            message = (_err$response$data$de9 = (_err$response12 = _context13.t0.response) === null || _err$response12 === void 0 ? void 0 : (_err$response12$data = _err$response12.data) === null || _err$response12$data === void 0 ? void 0 : (_err$response12$data$ = _err$response12$data.detail) === null || _err$response12$data$ === void 0 ? void 0 : (_err$response12$data$2 = _err$response12$data$[0]) === null || _err$response12$data$2 === void 0 ? void 0 : _err$response12$data$2.msg) !== null && _err$response$data$de9 !== void 0 ? _err$response$data$de9 : _context13.t0;
            console.error("Failed to fetch organization api keys: ".concat(message));
            return _context13.abrupt("return", [null, _context13.t0]);

          case 14:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 9]]);
  }));

  return function apiGetApiKeys(_x19) {
    return _ref15.apply(this, arguments);
  };
}();
export var apiCreateApiKey = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(organizationId, payload) {
    var res, _err$response$data$de10, _err$response13, _err$response13$data, _err$response13$data$, _err$response13$data$2, message;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;

            if (organizationId) {
              _context14.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            _context14.next = 5;
            return api.post("/organizations/".concat(organizationId, "/api_keys"), payload);

          case 5:
            res = _context14.sent;
            return _context14.abrupt("return", [res.data]);

          case 9:
            _context14.prev = 9;
            _context14.t0 = _context14["catch"](0);
            message = (_err$response$data$de10 = (_err$response13 = _context14.t0.response) === null || _err$response13 === void 0 ? void 0 : (_err$response13$data = _err$response13.data) === null || _err$response13$data === void 0 ? void 0 : (_err$response13$data$ = _err$response13$data.detail) === null || _err$response13$data$ === void 0 ? void 0 : (_err$response13$data$2 = _err$response13$data$[0]) === null || _err$response13$data$2 === void 0 ? void 0 : _err$response13$data$2.msg) !== null && _err$response$data$de10 !== void 0 ? _err$response$data$de10 : _context14.t0;
            console.error("Failed to create organization api key: ".concat(message));
            return _context14.abrupt("return", [null, _context14.t0]);

          case 14:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 9]]);
  }));

  return function apiCreateApiKey(_x20, _x21) {
    return _ref16.apply(this, arguments);
  };
}();
export var apiDeleteApiKey = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(organizationId, apiKeyId) {
    var res, _err$response$data$de11, _err$response14, _err$response14$data, _err$response14$data$, _err$response14$data$2, message;

    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;

            if (organizationId) {
              _context15.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            if (apiKeyId) {
              _context15.next = 5;
              break;
            }

            throw new Error("Invalid api key id: ".concat(apiKeyId));

          case 5:
            _context15.next = 7;
            return api["delete"]("/organizations/".concat(organizationId, "/api_keys/").concat(apiKeyId));

          case 7:
            res = _context15.sent;
            return _context15.abrupt("return", [res.data]);

          case 11:
            _context15.prev = 11;
            _context15.t0 = _context15["catch"](0);
            message = (_err$response$data$de11 = (_err$response14 = _context15.t0.response) === null || _err$response14 === void 0 ? void 0 : (_err$response14$data = _err$response14.data) === null || _err$response14$data === void 0 ? void 0 : (_err$response14$data$ = _err$response14$data.detail) === null || _err$response14$data$ === void 0 ? void 0 : (_err$response14$data$2 = _err$response14$data$[0]) === null || _err$response14$data$2 === void 0 ? void 0 : _err$response14$data$2.msg) !== null && _err$response$data$de11 !== void 0 ? _err$response$data$de11 : _context15.t0;
            console.error("Failed to delete organization api key: ".concat(message));
            return _context15.abrupt("return", [null, _context15.t0]);

          case 16:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[0, 11]]);
  }));

  return function apiDeleteApiKey(_x22, _x23) {
    return _ref17.apply(this, arguments);
  };
}();
export var apiUpdateOrganizationCategory = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(organizationId, categoryId) {
    var res, _err$response$data$de12, _err$response15, _err$response15$data, _err$response15$data$, _err$response15$data$2, message;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;

            if (organizationId) {
              _context16.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            _context16.next = 5;
            return api.post("organizations/".concat(organizationId, "/categories"), {
              category_ids: [categoryId]
            });

          case 5:
            res = _context16.sent;
            return _context16.abrupt("return", [res.data.data.organization]);

          case 9:
            _context16.prev = 9;
            _context16.t0 = _context16["catch"](0);
            message = (_err$response$data$de12 = (_err$response15 = _context16.t0.response) === null || _err$response15 === void 0 ? void 0 : (_err$response15$data = _err$response15.data) === null || _err$response15$data === void 0 ? void 0 : (_err$response15$data$ = _err$response15$data.detail) === null || _err$response15$data$ === void 0 ? void 0 : (_err$response15$data$2 = _err$response15$data$[0]) === null || _err$response15$data$2 === void 0 ? void 0 : _err$response15$data$2.msg) !== null && _err$response$data$de12 !== void 0 ? _err$response$data$de12 : _context16.t0;
            console.error("Failed to update organization category: ".concat(message));
            return _context16.abrupt("return", [null, _context16.t0]);

          case 14:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 9]]);
  }));

  return function apiUpdateOrganizationCategory(_x24, _x25) {
    return _ref18.apply(this, arguments);
  };
}();
export var apiGetOrganizationByQuoteId = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            _context17.next = 3;
            return api.get("/organizations/get_by_quote_id/".concat(payload.quote_id));

          case 3:
            res = _context17.sent;
            return _context17.abrupt("return", [res.data]);

          case 7:
            _context17.prev = 7;
            _context17.t0 = _context17["catch"](0);
            return _context17.abrupt("return", handleRequestError(_context17.t0));

          case 10:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 7]]);
  }));

  return function apiGetOrganizationByQuoteId(_x26) {
    return _ref19.apply(this, arguments);
  };
}();
export var apiDeleteOrganizationCompanyRegion = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            _context18.next = 3;
            return api["delete"]("/companies/region/delete/".concat(payload.region_id));

          case 3:
            res = _context18.sent;
            return _context18.abrupt("return", [res.data]);

          case 7:
            _context18.prev = 7;
            _context18.t0 = _context18["catch"](0);
            return _context18.abrupt("return", handleRequestError(_context18.t0));

          case 10:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0, 7]]);
  }));

  return function apiDeleteOrganizationCompanyRegion(_x27) {
    return _ref20.apply(this, arguments);
  };
}();